var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.className,domProps:{"innerHTML":_vm._s(_vm.all.chineseAssessmentResult.mandarinContent(_vm.isH5, _vm.all))}})
}
var staticRenderFns = []

export { render, staticRenderFns }